// File: cgp-sidenav.component.ts
// Author: Joseph M Diaz
// Date: 5/10/2017
// Desc: Sidenav component. Items are loaded fromt he config file.
// Other Contributors:

import { Component } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { PanelBarItemModel } from '@progress/kendo-angular-layout';
import { config } from '../../../config/config';


@Component({
    selector: 'cgp-sidenav',
    templateUrl: './cgp-sidenav.template.html'
})
export class CgpSidenavComponent {
    items: any;
    actions: any;
    selectedId = "";
    currentRoute: any;


    constructor(private readonly router: Router) {
        this.items = config.navItems;
        this.actions = config.navActions;
    }


    ngOnInit() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.currentRoute = event;
            }
        });
    }


    stateChange(data: Array<PanelBarItemModel>): boolean {
        const focusedEvent: PanelBarItemModel = data.filter(item => item.focused === true)[0];
        this.selectedId = focusedEvent.id;
        data.forEach(e => {
            const itemPath: PanelBarItemModel = e;
            itemPath.selected = true;
        });
        focusedEvent.selected = true;
        this.router.navigate(["/" + focusedEvent.id]);
        return false;
    }


    flattenItems(result, items) {
        for (let i = 0, l = items.length; i < l; i++) {
            const item = items[i];

            result.push(item);

            if (item.children && item.children instanceof Array) {
                this.flattenItems(result, item.children);
            }
        }

        return result;
    }


    isSelected(route): boolean {
        if (!this.currentRoute) return false;
        return '/' + route === this.currentRoute.url;
    }
}
